import { useMemo } from "react";

import { Lab } from "components/icons/generated";
import { MainNavigationItem } from "components/MainNavigation/types";
import useIntentProjectAccess from "shared/IntentProject/useIntentProjectAccess";

import {
  MAIN_NAVIGATION_PRIMARY_MENU_ITEMS,
  MainNavigationPrimaryMenuItemKeys,
} from "./menuItemsPrimary";

const useTryNewFeatures = (): MainNavigationItem | undefined => {
  const hasIntentProjectAccess = useIntentProjectAccess();

  const isNewFeaturesEnabled = hasIntentProjectAccess;

  return useMemo(() => {
    if (!isNewFeaturesEnabled) {
      return undefined;
    }

    return {
      id: "try-new-features",
      title: "Try New Features",
      icon: Lab,
      items: [
        {
          items: [
            ...(hasIntentProjectAccess
              ? [
                  MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[
                    MainNavigationPrimaryMenuItemKeys.IntentProjects
                  ],
                ]
              : []),
          ],
        },
      ],
    };
  }, [isNewFeaturesEnabled, hasIntentProjectAccess]);
};

export default useTryNewFeatures;
